import { usePortalPrivacyConsent } from '@/context/PortalPrivacyConsent';
import { PrivacyConsentValues } from '@/context/PortalPrivacyConsent/PortalPrivacyConsent.interface';
import React from 'react';

export const usePortalPrivacyConsentEvent = ({ callback = () => {}, enabled = true }) => {
  const { privacyConsent, onPrivacyConsentUpdated } = usePortalPrivacyConsent();

  React.useEffect(() => {
    if (!enabled) return;

    if (privacyConsent !== PrivacyConsentValues.CONSENT_NEEDED) {
      callback();
      return;
    }

    onPrivacyConsentUpdated(callback);
  }, [privacyConsent, callback, enabled, onPrivacyConsentUpdated]);
};
